import React, { useState, useEffect } from 'react';
import { OverflowDetector } from 'react-overflow';

// Components
import WpButton from '../button/WpButton';

// Styles
import './WpOverflowExpand.scss';

export interface Props {
  children?: React.ReactNode;
  height?: string;
  maxHeight?: string;
  seeMoreButtonLabel?: string;
  autoOpen?: boolean;
  buttonPadding?: string;
}

const WpOverflowExpand: React.FC<Props> = ({
  children,
  height,
  maxHeight,
  seeMoreButtonLabel = 'see more',
  autoOpen = false,
  buttonPadding,
}: Props) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const [isShowingAll, setIsShowingAll] = useState(false);
  const showExpandLink = isOverflowed && !isShowingAll;

  useEffect(() => {
    setIsShowingAll(autoOpen);
  }, [autoOpen]);

  function handleOverflowChange(isOverflowed) {
    setIsOverflowed(isOverflowed);
  }

  const style = { overflow: 'auto', width: '100%' };

  if (isShowingAll) {
    style['height'] = 'unset';
    style['maxHeight'] = 'unset';
  } else if (height) {
    style['height'] = height;
  } else if (maxHeight) {
    style['maxHeight'] = maxHeight;
  }

  if (showExpandLink) {
    style['overflow'] = 'hidden';
  } else {
    style['overflow'] = 'auto';
  }

  const baseClassName = 'WpOverflowExpand';
  return (
    <div className={baseClassName}>
      <OverflowDetector onOverflowChange={handleOverflowChange} style={style}>
        {children}
      </OverflowDetector>
      {showExpandLink && (
        <div style={{ paddingTop: buttonPadding }}>
          <WpButton size="sm" variant="tertiary" onClick={() => setIsShowingAll(true)}>
            {seeMoreButtonLabel}
          </WpButton>
        </div>
      )}
    </div>
  );
};

export default WpOverflowExpand;
